import React from 'react';
import withIcon from '../utilities/withIcon';

const IconTextbox = () => {
  return (
    <g>
      <path d="M15.3 5a.7.7 0 0 1 .694.605L16 5.7v4.6a.7.7 0 0 1-.605.694L15.3 11H.7a.7.7 0 0 1-.694-.605L0 10.3V5.7a.7.7 0 0 1 .605-.694L.7 5h14.6zm-.85 1.55H1.55v2.9h12.9v-2.9z" />
    </g>
  );
};

export default withIcon(IconTextbox);
